import { render, staticRenderFns } from "./EstDes2.vue?vue&type=template&id=86b67dd8&scoped=true&"
import script from "./EstDes2.vue?vue&type=script&lang=js&"
export * from "./EstDes2.vue?vue&type=script&lang=js&"
import style0 from "./EstDes2.vue?vue&type=style&index=0&id=86b67dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b67dd8",
  null
  
)

export default component.exports